import React from "react";

class MediaViewerImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onMarkerClick(id) {
    this.props.onSelectAnnotation(id);
  }

  addMarker() {
    if (this.props.addMarker)
      this.props.addMarker(this.state.mouseX, this.state.mouseY);
  }

  render() {
    const { annotations } = this.props;

    const markers = annotations.map((value, index, arr) => {
      return (
        <AnnotationMarker
          key={value.id}
          type={value.type}
          active={value.id === this.props.selectedAnnotation}
          positionX={value.marker.positionX}
          positionY={value.marker.positionY}
          onClick={() => this.onMarkerClick(value.id)}
        />
      );
    });

    return (
      <div
        id="Media"
        onMouseDown={e => {
          this.addMarker();
        }}
        onMouseMove={e => {
          this.setState({
            mouseX: Math.floor(
              (this.props.position.x / this.props.elementDimensions.width) * 100
            ),
            mouseY: Math.floor(
              (this.props.position.y / this.props.elementDimensions.height) *
                100
            )
          });
        }}
      >
        <img alt="Media Image" src={this.props.imageUrl} />
        {markers}
      </div>
    );
  }
}

export default MediaViewerImage;

class AnnotationMarker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const isGood = this.props.type === "good";
    return (
      <div
        className={
          "AnnotationMarker" +
          (isGood ? " AnnotationMarker-Good" : " AnnotationMarker-Bad") +
          (this.props.active ? " AnnotationMarker-Active" : "")
        }
        style={{
          top: `${this.props.positionY}%`,
          left: `${this.props.positionX}%`
        }}
        onClick={() => this.props.onClick()}
      />
    );
  }
}

const AnnotationMarkerPlacer = props => {
  return (
    <div
      className={"AnnotationMarkerPlacer" + (props.show ? "" : "-Hide")}
      style={{
        top: `${props.positionY}%`,
        left: `${props.positionX}%`
      }}
    >
      <p>
        <i className="fas fa-plus" />&nbsp; Anmerkung
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/MediaViewerImage.js